import { Link } from 'react-router-dom'
import { Star, Pencil } from 'lucide-react'

import { useAdmin } from '../providers/AdminProvider'
import { Button } from './ui/button'
import { Badge } from './ui/badge'

const ADMIN_MONI = 1004

const GephazLogo = () => (
  <div className="flex items-center gap-2">
    <img className="h-8 w-8" src="images/locomotive.png" alt="Gephaz" />
    <span className="font-semibold tracking-tight">Gépház</span>
  </div>
)

const UserData = ({ name, role }: { name: string; role: string }) => (
  <Badge variant="secondary" className="gap-1.5 px-3 py-1.5 text-xs font-medium">
    {name}
    {role === 'ADMIN' ? <Star className="h-3 w-3" /> : <Pencil className="h-3 w-3" />}
  </Badge>
)

export type HeaderAction = {
  title: string
  onClick: () => void
}

const Header = ({ actions = [] }: { actions?: HeaderAction[] }) => {
  const { adminName, role, id } = useAdmin()

  return (
    <header className="flex flex-col sm:flex-row sm:items-start sm:justify-between border-b border-zinc-200 bg-white px-6 py-3 gap-2 sm:gap-4">
      <Link to="/" className="shrink-0 py-1">
        <GephazLogo />
      </Link>

      <div className="flex items-center gap-1 flex-wrap sm:justify-end">
        {actions.map((action) => (
          <Button key={action.title} variant="ghost" size="sm" onClick={action.onClick}>
            {action.title}
          </Button>
        ))}

        <Button variant="ghost" size="sm" asChild>
          <Link to="/">Változások</Link>
        </Button>

        <Button variant="ghost" size="sm" asChild>
          <Link to="/old">Változások (régi UI)</Link>
        </Button>

        <Button variant="ghost" size="sm" asChild>
          <Link to="/new_laws">Új jogszabályok</Link>
        </Button>

        {role === 'ADMIN' && (
          <Button variant="ghost" size="sm" asChild>
            <Link to="/users">Felhasználók</Link>
          </Button>
        )}

        {role === 'ADMIN' && (
          <Button variant="ghost" size="sm" asChild>
            <Link to="/accounts">Ügyfelek</Link>
          </Button>
        )}

        {role === 'ADMIN' && id === ADMIN_MONI && (
          <Button variant="ghost" size="sm" asChild>
            <a href="https://robot.joxa.hu/auth/bdd1c77ff03bfcb6" target="_blank" rel="noreferrer">
              Belépés: MTSZ
            </a>
          </Button>
        )}

        <Button variant="ghost" size="sm" asChild>
          <a href="https://countwordsfree.com/comparetexts" target="_blank" rel="noreferrer">
            Összehasonlító
          </a>
        </Button>

        <Button variant="outline" size="sm" asChild>
          <a href="/logout">Kilépés</a>
        </Button>

        <UserData name={adminName} role={role} />
      </div>
    </header>
  )
}

export default Header
